export enum OsType {
  unknown = 'Unknown OS',
  mac = 'MacOS',
  windows = 'Windows',
  linux = 'Linux',
  unix = 'UNIX'
}

export enum DeviceType {
  android = 'Android',
  ios = 'iOS',
  desktop = 'desktop'
}

export interface Device {
  type: DeviceType;
  browser: string;
  os: OsType;
  label?: string;
}
